import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const facteurs = [
  { title: 'facteur_1_title', desc: 'facteur_1_desc', icon: 'ri-ruler-line' },
  { title: 'facteur_2_title', desc: 'facteur_2_desc', icon: 'ri-arrow-up-down-line' },
  { title: 'facteur_3_title', desc: 'facteur_3_desc', icon: 'ri-shape-line' },
  { title: 'facteur_4_title', desc: 'facteur_4_desc', icon: 'ri-hammer-line' },
  { title: 'facteur_5_title', desc: 'facteur_5_desc', icon: 'ri-building-3-line' },
  { title: 'facteur_6_title', desc: 'facteur_6_desc', icon: 'ri-truck-line' },
  { title: 'facteur_7_title', desc: 'facteur_7_desc', icon: 'ri-sun-line' },
];

export default function FacteursPrix() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="facteurs" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('facteurs_h2')}
      </h2>

      <div className="space-y-6">
        {facteurs.map((f, idx) => (
          <div
            key={idx}
            className={`flex gap-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 100 + 150}ms` }}
          >
            <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-copper/10">
              <i className={`${f.icon} text-copper`} />
            </div>
            <div>
              <h4 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-1">{t(f.title)}</h4>
              <p className="text-slate-primary/60 text-sm leading-relaxed">{t(f.desc)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}